





















import wamly from '~/mixins/wamly';

export default {
    name: 'JobsSidebarItem',

    mixins: [wamly],

    props: {
        job: {
            required: true,
            type: Object,
        },
        active: {
            default: false,
            required: false,
            type: Boolean,
        },
    },

    computed: {
        isBursary() {
            return this.job.job_type === 'Bursary';
        },

        modelRoute() {
            return this.isBursary ? this.localePath({ path: '/bursaries/' + this.job.uuid }) : this.localePath({ path: '/jobs/' + this.job.uuid });
        },

        statusColor() {
            if (this.job.status === 'Published') return 'bg-success';
            if (this.job.status === 'Unpublished') return 'bg-error';
            return 'bg-background-secondary';
        },
    },
};
